import { useEffect, useState } from 'react'
import "./range.scss"
import { toCamelCase } from 'lib/helpers';
const Range = ({ id, initialValue, minValue, min, max, inputName, unitType, onChange }: RangeProps) => {
    const [rangeValue, setRangeValue] = useState(initialValue !== undefined ? initialValue : 0);

    let valueInPercent;

    useEffect(() => {
        if (initialValue !== undefined) {
            setRangeValue(initialValue);
        }
    }, [initialValue]);

    const labelName = toCamelCase(inputName);

    valueInPercent = (rangeValue / max) * 100

    const handleRangeValueChange = (e) => {
        e.preventDefault();
        const value = Math.max(minValue, parseInt(e.target?.value || 0));
        onChange(value);
        setRangeValue(value);
    };

    return (
        <div className="xsd-range">
            <label
                className="msds-text-body-3 msds-text-gray-10"
                htmlFor={labelName}>
                {inputName} - {rangeValue} {unitType ? unitType : "%"}
            </label>
            <div className="xsd-range__input-wrapper">
                <input
                    id={id}
                    className="xsd-range__input"
                    type="range"
                    value={rangeValue}
                    min={min}
                    max={max}
                    name={labelName}
                    onChange={handleRangeValueChange}
                />
            </div>
            <div className="xsd-range__control-wrapper">
                <div className="xsd-range__rail">
                    <div
                        className="xsd-range__inner-rail msds-bg-clear-blue-gradient"
                        style={{
                            left: `${0}%`,
                            right: `${100 - (valueInPercent !== undefined ? valueInPercent : 0)}%`
                        }}
                    />
                </div>
                <div
                    className="xsd-range__control"
                    style={{
                        left: `${valueInPercent !== undefined ? valueInPercent : 0}%`
                    }}
                />
            </div>
            {(minValue >= 0 && rangeValue < minValue + 5) &&
                <div className="xsd-range__warning msds-text-body-4 msds-text-danger-red-1">
                    Minimum is {minValue} {unitType ? unitType : "%"}
                </div>
            }
        </div>
    );
};
export default Range;

type RangeProps = {
    id?: string;
    initialValue?: number;
    minValue?: number; //For validation message
    min: number;
    max: number;
    inputName: string;
    unitType?: string;
    onChange: (value) => void;
}